import React from 'react';

interface DrawTakerOption {
  _id: string;
  no: number | string;
  firstName?: string;
  lastName?: string;
}

interface FaceOffSectionProps {
  midfieldPlayers: DrawTakerOption[];
  otherPlayers: DrawTakerOption[];
  drawTakerId: string;
  onDrawTakerChange: (playerId: string) => void;
  onUsFaceOff: () => void;
  onThemFaceOff: () => void;
  actionFeedback?: string | null;
  themDisabled?: boolean;
}

const playerLabel = (p: DrawTakerOption) => `#${p.no} ${p.firstName || ''} ${p.lastName || ''}`.trim();

const FaceOffSection: React.FC<FaceOffSectionProps> = ({
  midfieldPlayers,
  otherPlayers,
  drawTakerId,
  onDrawTakerChange,
  onUsFaceOff,
  onThemFaceOff,
  actionFeedback,
  themDisabled = false,
}) => (
  <div>
    <div className="relative z-10 px-3 pb-3">
      <label htmlFor="draw-taker" className="block text-2xl font-bold text-center mb-2">
        Draw Taker
      </label>
      <select
        id="draw-taker"
        className="w-full rounded-lg border-2 border-sd-line bg-white px-3 py-3 text-lg font-semibold text-sd-ink focus:outline-none focus:ring-2 focus:ring-sd-green"
        value={drawTakerId}
        onChange={(e) => onDrawTakerChange(e.target.value)}
      >
        <option value="">Select draw taker</option>
        {midfieldPlayers.map((p) => (
          <option key={p._id} value={String(p._id)}>
            {playerLabel(p)}
          </option>
        ))}
        {otherPlayers.length > 0 && (
          <optgroup label="Other Players">
            {otherPlayers.map((p) => (
              <option key={p._id} value={String(p._id)}>
                {playerLabel(p)}
              </option>
            ))}
          </optgroup>
        )}
      </select>
    </div>
    <div className="relative text-2xl font-bold text-center z-10">Draw Control Won</div>
    <div className="relative flex w-full justify-between items-stretch gap-4 z-10 py-3 px-3 h-[80x]">
      <div className="flex-1 flex justify-center">
        <button
          type="button"
          className="w-full font-bold rounded-lg px-3 xs:px-6 py-4 text-center flex justify-center items-center shadow-lg cursor-pointer bg-sd-green text-black"
          onClick={onUsFaceOff}
        >
          <div className="text-xl sm:text-2xl">US</div>
        </button>
      </div>
      <div className="flex-1 flex justify-center">
        <button
          type="button"
          className={`w-full font-bold rounded-lg px-3 xs:px-6 py-4 text-center flex justify-center items-center shadow-lg transition-all ${
            actionFeedback === 'THEM_DRAW_CONTROL' ? 'bg-white text-black' : 'bg-sd-navy text-white'
          } ${themDisabled ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'}`}
          onClick={onThemFaceOff}
          disabled={themDisabled}
        >
          <div className="text-xl sm:text-2xl">THEM</div>
        </button>
      </div>
    </div>
  </div>
);

export default FaceOffSection;
